import React from 'react'

/**
 * Sibling to UI2FormSectionErrorContext: bound fields report "unfilled" for the wizard's
 * silent-replay auto-advance gate. Disabled/read-only fields never count (can't be filled).
 */
export interface IUI2FormSectionFillContext {
  reportUnfilled: (id: string, isUnfilled: boolean) => void
}

const noop: IUI2FormSectionFillContext = { reportUnfilled: () => undefined }

export const UI2FormSectionFillContext = React.createContext<IUI2FormSectionFillContext>(noop)
